import './App.css'
import PasswordManager from './Components/PasswordManager'

const App = () => <PasswordManager />

export default App
